export default __webpack_public_path__ + "static/media/madara.05f92926.png";